__turbopack_context__.v({
  "adLeaderboard": "si8C0a_adLeaderboard",
  "adMidBanner": "si8C0a_adMidBanner",
  "articles": "si8C0a_articles",
  "callout": "si8C0a_callout",
  "container": "si8C0a_container",
  "content": "si8C0a_content",
  "sidebar": "si8C0a_sidebar",
  "sidebarDisabled": "si8C0a_sidebarDisabled",
});
